import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=0cdbc0a0&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"
import style0 from "./audio.vue?vue&type=style&index=0&id=0cdbc0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbc0a0",
  null
  
)

export default component.exports